/**
 * @providesModule PhoneVerifyStyle
 * 
 */

import Sizes from 'Sizes';
import SkillzStyle from 'SkillzStyle';
import SKZConstants from 'SKZConstants';
import {StyleSheet} from 'react-native';

const SCROLL_ITEMS_VERTICAL_MARGIN = 30;
const CELL_MARGIN_PHONE = 10;
const CELL_MARGIN_TABLET = 12;

const {
  viewCornerRadiusPrimary,
  textColorPrimary,
  fontSizeH1,
  fontSizeH2,
  fontSizeH3,
  fontSizeH4,
  fontRegular,
  btnTextColorOne,
  textColorSecondary,
  fontSecondary,
} = SkillzStyle.fullStyles;

const styles = StyleSheet.create({
  backgroundContainer: {
    alignSelf: 'stretch',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    flex: 1,
  },

  consentBox: {
    marginBottom: 15,
  },

  scrollViewContainer: {
    flex: 1,
    alignSelf:'center',
    overflow:'visible',
  },

  scrollViewContentContainer: {
    alignSelf:'center',
    alignItems:'center',
    justifyContent: 'center',
    ...Sizes.select({
      tablet: {
        maxWidth: 380,
      },
      portraitPhone: {
      },
      landscapePhone: {
        maxWidth: 320,
      },
    }),
  },

  shieldImageStyle: {
    marginTop: SCROLL_ITEMS_VERTICAL_MARGIN,
    ...Sizes.select({
      portrait: {
        width: 150,
        height: 120,
        marginBottom: 20,
      },
      landscape: {
        width: 100,
        height: 80,
        marginBottom: 10,
      },
    }),
  },

  closeButtonContainer: {
    position: 'absolute',
    alignSelf: 'flex-end',
    ...Sizes.select({
      tablet: {
        right: 20,
        margin: 20,
      },
      phone: {
        right: 10,
        margin: 10,
      },
    }),
  },

  closeButton: {
    ...Sizes.select({
      tablet: {
        height: 24,
        width: 24,
      },
      phone: {
        height: 15,
        width: 15,
      },
    }),
    marginTop: Sizes.isNotchedIphone() && Sizes.isPortrait() ? SKZConstants.IPHONEX_NOTCH_HEIGHT_PORTRAIT : 10,
    marginRight: 10,
  },

  sendBtnContainer: {
    height: 45,
    width: Sizes.select({
      tablet: 94,
      phone: 80,
    }),
  },

  pushBtnText: {
    ...fontSecondary,
    ...btnTextColorOne,
    ...fontSizeH4,
  },

  numberAndSendContainer: {
    flexDirection: 'row',
    ...viewCornerRadiusPrimary,
    marginHorizontal: Sizes.select({
      portrait: 10,
      landscape: 0,
    }),
    alignSelf: 'center',
  },

  messageContainer: {
    marginBottom: 6,
    ...viewCornerRadiusPrimary,
  },

  phoneVerifyLabel: {
    ...fontSecondary,
    ...textColorPrimary,
    ...Sizes.select({
      landscapePhone: fontSizeH2,
      other: fontSizeH1,
    }),
    textAlign: 'center',
    alignSelf: 'center',
  },

  requireMessageLabel: {
    ...fontRegular,
    ...fontSizeH4,
    ...textColorPrimary,
    marginHorizontal: Sizes.select({
      portrait: 12,
      landscape: 15,
    }),
    ...Sizes.select({
      phone: {
        height: 48,
        marginTop: 0,
        marginBottom: 2,
      },
      tablet:{
        height: 50,
        marginTop: 6,
        marginBottom: 18,
      },
    }),
    ...fontSizeH3,
    textAlign: 'center',
  },

  submitVerificationContainer: {
    ...viewCornerRadiusPrimary,
    marginHorizontal: Sizes.select({
      portrait: 10,
      landscape: 0,
    }),
    marginBottom: 40,
    alignSelf: 'stretch',
  },

  verificationsInputText: {
    textAlign: 'center',
    flex: 1,
    ...textColorSecondary,
    ...fontRegular,
    ...fontSizeH4,
  },

  inputText: {
    padding: 0,
    flex: 1,
    marginLeft: 8,
  },

  inputTextStyle: {
    textAlign: 'left',
    textAlignVertical: 'center',
    ...textColorSecondary,
    ...fontRegular,
    ...fontSizeH4,
    flex: 1,
  },

  numberInputContainer: {
    backgroundColor: 'white',
    ...viewCornerRadiusPrimary,
    marginRight: 12,
    height: 45,
    flex: 1,
  },

  verificationsInputContainer: {
    backgroundColor: 'white',
    ...viewCornerRadiusPrimary,
    ...Sizes.select({
      phone: {
        marginVertical: CELL_MARGIN_PHONE,
      },
      tablet: {
        marginVertical: CELL_MARGIN_TABLET,
      },
    }),
    height: 45,
  },

  submitBtnContainer: {
    alignSelf: 'center',
    width: Sizes.select({
      phone: 130,
      tablet: 150,
    }),
    height: Sizes.select({
      phone: 35,
      tablet: 45,
    }),
  },

  messageStyle: {
    ...fontSizeH4,
    ...fontRegular,
    color: '#4A4A4A',
    paddingVertical: 20,
    paddingHorizontal: 40,
    textAlign: 'center',
  },
});

export default styles;
